<script lang="ts">
    import { _ } from 'svelte-i18n';

    import ButtonMain from '../ButtonMain.svelte';
    import { type AvailableWidgetType } from '../../components/Dashboard/availableWidgets';
    import { closeModal } from 'svelte-modals';

    export let isOpen: boolean = false;
    export let onSelect: (componentId: number) => void;
    export let availableWidgets: AvailableWidgetType[];
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="dialog-container">
            <div class="dialog-header">{$_('Create widget')}</div>

            <div class="available-widget-list">
                {#each availableWidgets.filter(w => w.enabled) as widget}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div
                        class="widget-add-item"
                        on:click={() => {
                            closeModal();
                            onSelect(widget.id);
                        }}
                    >
                        <div class="widget-item__name">
                            <div class="widget-add-item-icon"></div>
                            <div class="widget-add-item-name">{$_(widget.title)}</div>
                        </div>
                    </div>
                {/each}
            </div>

            <div class="actions"></div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .dialog-container {
        pointer-events: auto;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        min-width: 590px;
        max-width: 590px;
        min-height: 300px;
        row-gap: 10px;
        background-color: #dbdbd6;
        padding: 20px;
        border-radius: 6px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
    }

    .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        font-weight: 600;
        font-size: 18px;
        height: 40px;
        padding: 10px 10px 20px 10px;
    }

    .js-dialog-container {
        flex: 10 1 auto;
        padding: 10px;
    }
    .actions {
        border-top: 1px solid #ccc;
        padding: 20px 10px 10px 10px;
        column-gap: 20px;
        display: flex;
        justify-content: space-between;
    }

    .available-widget-list {
        display: flex;
        flex-direction: column;
        row-gap: 6px;
    }
    .available-widget-list .widget-add-item {
        border-radius: 3px;
        background-color: #f5f5f5;
        border: 1px solid #eee;
        cursor: pointer;
    }
    .available-widget-list .widget-item__name {
        display: flex;
        flex-direction: row;
        height: 40px;
        margin: 5px 5px;
    }
    .available-widget-list .widget-add-item-icon {
        flex: 0 0 30px;
        display: flex;
        align-items: center;
        height: 100%;
    }
    .available-widget-list .widget-add-item-name {
        flex: 1 1 250px;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
</style>
